<template>
  <b-modal
    id="modal-vehicle-support"
    size="lg"
    :title="$t('rjm.supportedVehicles')"
    centered
    data-me="rjm-component-modal-vehicle-support"
  >
    <McGrapqlTable
      :apiClient="query"
      :fields="fields"
      :showPagination="true"
      :stickyHeader="true"
      :hasCheckbox="false"
      data-me="rjm-component-modal-vehicle-support-table"
    >
      <template #cell(featureSupported)="{ value, item }">
        <span
          v-b-tooltip.hover.right="{
            title: getFeatureSupportTooltip(item.featureNetworkMode),
            disabled: !value,
          }"
          :class="`mc-status mc-status--${value ? 'green' : 'red'}`"
        >
          {{ getFeatureSupportLabel(value, item.featureNetworkMode) }}
        </span>
      </template>
    </McGrapqlTable>

    <template #modal-footer="{ cancel }">
      <McButton
        variant="primary"
        :text="$t('global.action.close')"
        @click="cancel()"
        data-me="rjm-component-modal-vehicle-support-button-close"
      />
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import McGrapqlTable from '@/components/McGrapqlTable'
import { vehicleSupport } from '@/services/api/master/rjm'

export default {
  name: 'ModalVehicleSupport',
  components: { McButton, McGrapqlTable },
  props: {
    items: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'licensePlate',
          label: this.$t('global.object.licensePlate'),
          shown: true,
        },
        {
          key: 'vehicleType.type',
          label: this.$t('global.field.vehicleType'),
          shown: true,
        },
        {
          key: 'vehicle2Vgroup',
          label: this.$t('global.object.fleetGroup'),
          shown: true,
          formatter: (val) => {
            if (!val || !Array.isArray(val) || val.length === 0) return '-'
            return val
              .map((item) => item.vgroup?.name)
              .filter(Boolean)
              .join(', ')
          },
        },
        {
          key: 'featureSupported',
          label: this.$t('rjm.deviceSupport'),
          shown: true,
        },
      ],
    }
  },
  computed: {
    query() {
      return {
        get: async (opts = {}) => {
          const page = opts.pagination?.page || 1
          const show = opts.pagination?.show || 10
          const search = opts.search || ''

          if (this.items && page === 1 && show === 10 && !search) {
            return {
              data: this.items.data,
              pagination: {
                total: this.items.pagination.total,
                page: this.items.pagination.page,
                show: this.items.pagination.show,
              },
            }
          }

          const filter = {
            feature: 'RJM_GEOFENCE',
            pagination: {
              page,
              show,
            },
            search,
            withUnsupportedVehicles: true,
          }
          const res = await this.$apollo.query({
            query: vehicleSupport,
            fetchPolicy: 'no-cache',
            variables: { filter },
          })

          const vSupport = res.data.vehiclesByFeatureSupport.vehiclesByFeatureSupport

          return {
            data: vSupport.data,
            pagination: {
              total: vSupport.pagination.total,
              page: vSupport.pagination.page,
              show: vSupport.pagination.show,
            },
          }
        },
      }
    },
  },
  methods: {
    getFeatureSupportLabel(isSupported, networkMode) {
      if (!isSupported) return this.$t('rjm.deviceSupportNo')

      return String(networkMode).toLowerCase() === 'offline'
        ? this.$t('rjm.deviceSupportNoInternet')
        : this.$t('rjm.deviceSupportInternetRequired')
    },
    getFeatureSupportTooltip(networkMode) {
      return String(networkMode).toLowerCase() === 'offline'
        ? this.$t('rjm.deviceSupportNoInternetTooltip')
        : this.$t('rjm.deviceSupportInternetRequiredTooltip')
    },
  },
}
</script>
